<template>
  <v-row class="pr-3 main">
    <v-col>
      <v-row no-gutters>
        <v-col style="max-width: 200px">
          <v-img
            height="64"
            :src="templateSelected.primaryLogo"
            contain
            position="top left"
          />
        </v-col>
        <v-col style="max-width: 200px">
          <v-img
            v-if="templateSelected.secondaryLogo"
            height="64"
            :src="templateSelected.secondaryLogo"
            class="ml-4"
            contain
            position="top left"
          />
        </v-col>
      </v-row>
    </v-col>
    <v-col class="body-2">
      <v-row class="justify-end">
        {{ templateSelected.primaryWebAddress }}
        <br />
        {{ templateSelected.secondaryWebAddress }}
      </v-row>
    </v-col>
  </v-row>
</template>

<script>
import { mapGetters, mapState } from 'vuex';

export default {
  name: 'nonmapHeader',
  computed: {
    ...mapState({
      facilityTemplate: 'facilityTemplate',
      geographyTemplate: 'geographyTemplate'
    }),
    ...mapGetters({
      selectedItemType: 'mapTemplate/selectedItemType'
    }),
    templateSelected: function () {
      if (this.selectedItemType == 'Facility') {
        return this.facilityTemplate;
      } else {
        return this.geographyTemplate;
      }
      return false;
    }
  }
};
</script>

<style lang="sass" scoped>
.main
  page-break-before: always
</style>
